import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidation {
  static QtyLimit(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if ([undefined, null, ''].includes(control.value)) {
        return null;
      }
      if (+control.value > max) { 
        return { qtyLimit: true };
      }
      return null;
    };
  }

  static arrayMin(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!Array.isArray(control.value)) {
        return null; // don't validate other than array
      }
      return control.value.length >= min ? null : { arrayMin: true };
    };
  }

  static decimal(pattern: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const patternSplit = pattern.split(':');
      let beforeNum;
      if (patternSplit[0]) {
        beforeNum = `^(?!\\.?$)[\\d ()+-]{0,${patternSplit[0]}}(\\.\\d{0,${
          patternSplit[1]
        }})?$`;
      } else {
        beforeNum = `^(?!\\.?$)[\\d ()+-]+(\\.\\d{0,${patternSplit[1]}})?$`;
      }
      beforeNum = new RegExp(beforeNum);
      return !control.value
        ? null
        : beforeNum.test(control.value)
          ? null
          : { decimal: `Only requires ${patternSplit[1]} digits after decimal` };
    };
  }
}